import { skipToken, useMutation, useQuery } from "@tanstack/react-query";
import { baseApi } from "./baseApi";

export const useGetTrendingSymbols = (type?: string) => {
  return useQuery({
    queryKey: ["get-trending-symbols", type],
    queryFn: !type
      ? skipToken
      : async () => {
          const response = await baseApi.get(
            `/get_search_items_suggestions?type=${type}`
          );
          return response;
        },
    retry: 0,
    staleTime: 3000,
  });
};

export const useGetInstrumentSuggestion = (userId?: string, type?: string) => {
  return useQuery({
    queryKey: ["get-instrument-suggestions", userId, type],
    queryFn: !userId
      ? skipToken
      : async () => {
          const response = await baseApi.get(
            `/get_instrument_suggestions?instrument=EURGBP&server=AP&user_id=${userId}&type=${
              type ?? "forex"
            }`
          );
          return response;
        },
    retry: 0,
    staleTime: 3000,
  });
};

export const useGetTickerSnapshot = (symbol?: string) => {
  return useQuery({
    queryKey: ["get-tickers-snapshot", symbol],
    queryFn: !symbol
      ? skipToken
      : async () => {
          const response = await baseApi.get(
            `/get_tickers_snapshot?tickers=${symbol}`
          );
          return response;
        },
    retry: 0,
    staleTime: 3000,
  });
};

export const useGetTickerData = () => {
  return useMutation({
    mutationKey: ["get_ticker_data"],
    mutationFn: async ({
      user_id,
      ticker,
      timestamp,
      strategy_id,
    }: {
      ticker: string;
      timestamp: string;
      strategy_id?: string | number;
      user_id: string;
    }) => {
      const queryParams = new URLSearchParams({
        ticker,
        timestamp,
        user_id,
      });

      if (strategy_id !== undefined && strategy_id !== null) {
        queryParams.append("strategy_id", strategy_id.toString());
      }

      const response = await baseApi.get(
        `/get_ticker_data_v2?${queryParams.toString()}`
      );

      return response;
    },
  });
};

export const useGetForwardTestMetrics = () => {
  return useMutation({
    mutationKey: ["forward_test_metrics"],
    mutationFn: async ({
      user_id,
      deployment_id,
    }: {
      user_id: string;
      deployment_id: string;
    }) => {
      const response = await baseApi.get(
        `/forward_test_metrics?user_id=${user_id}&deployment_id=${deployment_id}`
      );
      return response;
    },
  });
};

export const useGetSymbolData = () => {
  return useMutation({
    mutationKey: ["get_symbol_data_v2"],
    mutationFn: async ({
      ticker,
      user_id,
    }: {
      ticker: string;
      user_id: string;
    }) => {
      const response = await baseApi.get(
        `/get_symbol_data_v2?ticker=${ticker}&user_id=${user_id}`
      );
      return response;
    },
    retryDelay: 2000,
  });
};

export const useGetSwapValues = () => {
  return useMutation({
    mutationKey: ["get_swap_values"],
    mutationFn: async ({
      user_id,
      strategy_id,
      deployment_id,
    }: {
      user_id: string;
      strategy_id: string;
      deployment_id: string;
    }) => {
      const response = await baseApi.get(
        `/get_swap_values?user_id=${user_id}&strategy_id=${strategy_id}&deployment_id=${deployment_id}`
      );
      return response;
    },
    retryDelay: 2000,
  });
};
